import React from 'react';
import { useTheme } from '../hooks/useTheme';

const NotFound = () => {
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen flex items-center justify-center p-8 transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-gray-900 to-gray-800' 
        : 'bg-gradient-to-br from-gray-50 to-gray-200'
    }`}>
      <div className={`max-w-2xl mx-auto rounded-2xl shadow-lg p-8 text-center transition-colors duration-300 ${
        theme === 'dark' 
          ? 'bg-gray-800/90 text-white' 
          : 'bg-white/90 text-gray-900'
      }`}>
        <h1 className={`text-9xl font-bold mb-4 ${
          theme === 'dark' ? 'text-primary-light' : 'text-primary'
        }`}>
          404
        </h1>
        <h2 className={`text-3xl font-semibold mb-6 ${
          theme === 'dark' ? 'text-white' : 'text-gray-900'
        }`}>
          Page Not Found
        </h2>
        <p className={`text-lg mb-8 ${
          theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
        }`}>
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
      </div>
    </div>
  );
};

export default NotFound; 